export const CENTER_POINT_LONGITUDE = 32.829256;
export const CENTER_POINT_LATITUDE = -79.83369;

// TODO: Data fields should be fetched from API, this should be selectable from UI
export const DATA_FIELDS_STR = "&df=rsrp&df=rssi";
